import * as React from 'react';
import sharedStyles from '../../../styles';

const CannotInspector = ({problem}) => {
  const styles = {
    ...sharedStyles.paneLayout,
    ...sharedStyles.theme,
  };

  return (
    <>
      <header css={[styles.header, styles.dark]}>
          Cannot inspect
      </header>
      <main css={[styles.section, styles.dominantSection]}>
        {problem}
      </main>
    </>
  );
};

export default CannotInspector;
